export const categoryNames: Record<string, string> = Object.freeze({
  QUESTION: 'question',
  ADVICE: 'advice',
  DISCUSSION: 'discussion',
  OFFICIAL: 'official',
  WIN_WIRE: 'deal_story',
});

type CategoryProperties = {
  title: string;
  hint: string;
  public: boolean;
  color: string;
  slug: typeof categoryNames[keyof typeof categoryNames];
};

export const categoryData: Record<string, CategoryProperties> = {
  [categoryNames.QUESTION]: {
    title: 'Question',
    hint: 'Get answers from fellow War Room members',
    public: true,
    color: '#E7C7EF',
    slug: categoryNames.QUESTION,
  },
  [categoryNames.ADVICE]: {
    title: 'Advice',
    hint: 'Share your experience or provide recommendations',
    public: true,
    color: '#FFDAB3',
    slug: categoryNames.ADVICE,
  },
  [categoryNames.DISCUSSION]: {
    title: 'Discussion',
    hint: 'Start conversations or share your opinion',
    public: true,
    color: '#BCDBDF',
    slug: categoryNames.DISCUSSION,
  },
  [categoryNames.OFFICIAL]: {
    title: 'Official',
    hint: 'Official announcement from Bravado',
    public: false,
    color: '#000000',
    slug: categoryNames.OFFICIAL,
  },
  [categoryNames.WIN_WIRE]: {
    title: 'Win wire',
    hint: 'Hit the gong and celebrate your deals with the War Room community',
    public: true,
    color: '#D6D8E1',
    slug: categoryNames.WIN_WIRE,
  },
};

export const categories = [
  categoryNames.QUESTION,
  categoryNames.ADVICE,
  categoryNames.DISCUSSION,
  categoryNames.WIN_WIRE,
  categoryNames.OFFICIAL,
].map(category => {
  return {
    name: category,
    ...categoryData[category],
  };
});

export const SUGGESTED_CATEGORY_TITLE = 'Suggested by members';
